/** @format */
import { css } from 'styled-components';

import { largeTablet, smallTablet } from '@toucan/client/global/application';

export const styles = () => css`
    display: grid;
    gap: var(--layout-spacing-24);
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
        'top right'
        'bottom right';

    figure:nth-child(1) {
        grid-area: top;
    }

    figure:nth-child(2) {
        grid-area: right;
    }

    figure:nth-child(3) {
        grid-area: bottom;
    }

    ${largeTablet(css`
        grid-template-columns: 1fr 1fr;
    `)}

    ${smallTablet(css`
        grid-template-columns: 1fr;
        gap: var(--layout-spacing-16);
        grid-template-areas:
            'top'
            'right'
            'bottom';
    `)}
`;
